import React, { useState, useEffect } from "react";
import { Modal, Card, Typography } from "antd"; 
import { fetchDietaryPreferences } from "../useAPIDetails/useFetchUserList"; 

const DietaryPreferencesModal = ({ userId, isOpen, onClose }) => {
  const [dietaryPreferences, setDietaryPreferences] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      const loadDietaryPreferences = async () => {
        setIsLoading(true);
        setError("");
        try {
          const response = await fetchDietaryPreferences(userId); 
          const diets = response || [];
          const transformedData = diets.map((diet) => ({
            name: diet.name,
            fileUrl: diet.coverPhoto?.fileUrl || "", 
          }));
          setDietaryPreferences(transformedData);
        } catch (err) {
          setError(
            err?.response?.data?.message ||
              "Failed to fetch dietary preferences."
          );
        } finally {
          setIsLoading(false);
        }
      };

      loadDietaryPreferences();
    }
  }, [isOpen, userId]);

  return (
    <Modal
      title="Dietary Preferences"
      open={isOpen}
      onCancel={() => {
        onClose();
        document.body.style.overflow = ""; // Re-enable scrolling
      }}
      footer={null}
      centered
      styles={{
        body: {
          maxHeight: "55vh",
          overflowY: "auto",
          scrollbarWidth: "thin",
        },
      }}
      style={{ maxWidth: "400px", margin: "auto" }}
      afterOpenChange={(open) => {
        document.body.style.overflow = open ? "hidden" : ""; // Handle background scrolling
      }}
    >
      {isLoading ? (
        <div>Loading......</div>
    ) : error ? (
        <Typography style={{ color: "red" }}>{error}</Typography>
      ) : (
        <div
          className="modal-dialog"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {dietaryPreferences.map((diet, index) => (
            <Card
              key={index}
              style={{
                backgroundImage: `url('${diet.fileUrl}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "8px",
                overflow: "hidden",
                height: "170px",
              }}
              styles={{
                body: {
                  height: "100%",
                  display: "flex",
                  alignItems: "flex-end",
                  padding: 0
                },
              }}
            >
              <Typography
                style={{
                  color: "#fff",
                  fontSize: "14px",
                  background: "rgba(0, 0, 0, 0.5)",
                  padding: "4px",
                }}
              >
                {diet.name}
              </Typography>
            </Card>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default DietaryPreferencesModal;
